const cartItems = [
  {
    img: 'https://t.ctcdn.com.br/m2IPX1ipSHh1AnY-5HAEtkQvIlA=/fit-in/600x600/filters:fill(transparent):watermark(wm/prd.png,-32p,center,1,none,15)/i914455.png',
    id: 'rec1JZlfCIBOPdcT23',
    title: 'Samsung Flip 6',
    price: 299.99,
    amount: 1
  },
  {
    id: 'rec1JZlfCIBOPdcT2',
    title: 'Samsung Galaxy A56 256GB',
    price: 299.99,
    img: 'https://t.ctcdn.com.br/HkO3jKS7Jt8iUmYGu9PA1uXEqX0=/fit-in/400x400/filters:fill(transparent):watermark(wm/prd.png,-32p,center,1,none,15)/i987123.png',
    amount: 1
  },
  {
    id: 'recB6qcHPxb62YJ75',
    title: 'Xiaomi 11 Pro',
    price: 499.99,
    img: 'https://www.kibotek.com/wp-content/uploads/2022/03/kiboTEK_NOTE11_PRO_PLUS_002.png',
    amount: 1
  },
  {
    id: 'recdRxBsE14Rr2VuJ',
    title: 'Motorola Moto G35 5G',
    price: 699.99,
    img: 'https://brmotorolanew.vtexassets.com/arquivos/ids/171427/frente-smartphone-moto-g35-grafite.png?v=638798024743630000',
    amount: 1
  },
  {
    id: 'recwTo160XST3PIoW',
    title: 'Sony Xperia M5',
    price: 599.99,
    img: 'https://www.saldaodainformatica.com.br/8920-home_default/celular-sony-xperia-m5-e5653-preto-16gb-android-50.jpg',
    amount: 1
  }
]
export default cartItems
